/* unplugin-vue-components disabled */import { render } from "./add-modal.vue?vue&type=template&id=1a391253&scoped=true"
import script from "./add-modal.vue?vue&type=script&lang=js"
export * from "./add-modal.vue?vue&type=script&lang=js"

import "./add-modal.vue?vue&type=style&index=0&id=1a391253&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a391253"],['__file',"src/pages/tenants/user/companies/add-modal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1a391253"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1a391253', __exports__)) {
    api.reload('1a391253', __exports__)
  }
  
  module.hot.accept("./add-modal.vue?vue&type=template&id=1a391253&scoped=true", () => {
    api.rerender('1a391253', render)
  })

}


export default __exports__